import { Button } from '@ophelos/ui/components/button';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@ophelos/ui/components/command';
import { Popover, PopoverContent, PopoverTrigger } from '@ophelos/ui/components/popover';
import { Check, ChevronsUpDown, Globe } from 'lucide-react';
import { useState } from 'react';
import { cn } from '@/lib/utils';
import { useCell } from './cell-context';

export function GlobalCellSwitcher({ size = 'default' }: { size?: 'sm' | 'default' }) {
  const { cells, cell, selectCell } = useCell();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          size={size === 'sm' ? 'xs' : 'default'}
          className="bg-accent/50 hover:bg-accent/75 border border-ring/25 hover:border-ring/50 text-accent-foreground dark:bg-accent dark:hover:bg-accent/75 dark:border-ring mx-2 shadow-none gap-3 px-2 text-sm font-normal"
        >
          <Globe className="size-3.5" />
          <span className="max-w-[150px] truncate">{cell.name}</span>
          <ChevronsUpDown className="h-3 w-3 text-accent-foreground opacity-10" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[280px] p-0 rounded-xl!">
        <Command>
          <CommandInput placeholder="Search market..." />
          <CommandList>
            <CommandEmpty>No market found.</CommandEmpty>
            <CommandGroup heading="Markets">
              {cells.map((item) => (
                <CommandItem
                  key={item.operator_id}
                  onSelect={() => {
                    if (item.operator_id !== cell.operator_id) selectCell(item);
                    setOpen(false);
                  }}
                  className="text-sm"
                >
                  <div className="flex flex-col flex-1">
                    <span className="font-medium">{item.name}</span>
                    <span className="text-xs text-muted-foreground">
                      {item.code} • {item.headquarters_country}
                    </span>
                  </div>
                  <Check
                    className={cn(
                      'ml-2 h-4 w-4 shrink-0 text-accent-foreground',
                      cell.operator_id === item.operator_id ? 'opacity-100' : 'opacity-0'
                    )}
                  />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
